import React from 'react';
import { Row, Col, Image, Space, Typography, Grid } from 'antd';
import Pict from '../../assets/img/wchss-pict-1.png';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function Welcome() {
  const { xs } = useBreakpoint()
  return (
    <React.Fragment>
      {
        xs ?
          <Row className='content-body' justify="space-around" align="middle" gutter={[0,32]} style={{ backgroundColor: '#fff' }}>
            <Col span={24}>
              <Image
                width={'100%'}
                src={Pict}
                preview={false}
                style={{ objectFit: 'cover' }}
              />
            </Col>
            <Col span={24}>
              <Space direction="vertical" size={16}>
                <Space direction="vertical" size={-8}>
                  <Text style={{ fontSize: 20, fontWeight: 'bold' }}>Welcome to The 2nd World Conference</Text>
                  <Text style={{ fontSize: 20, fontWeight: 'bold' }}>on Health and Social Sciences</Text>
                </Space>
                <Space direction="vertical" size={16}>
                  <Text style={{ fontSize: 15 }}>Join us for an enlightening exploration of the intersection between health and social sciences at Universitas Binawan. Under the theme of "Connecting People in Health and Social Sciences," this conference promises to be a platform for groundbreaking discussions, innovative ideas, and collaborative networking.</Text>
                  <Text style={{ fontSize: 15 }}>Explore cutting-edge topics such as artificial intelligence (AI) in healthcare, the integration of nursing and midwifery into public health systems, and the impact of virtual reality (VR) on safety education. Whether you're a researcher, practitioner, educator, or enthusiast, WCHSS offers a unique opportunity to engage with global thought leaders and contribute to the advancement of these vital fields.</Text>
                  {/* <Text style={{ fontSize: 15 }}>"This activity aims to develop and evaluate research-based interventions to improve public health, reduce social inequalities in health, and communicate research results and implications to a wide range of audiences."</Text> */}
                </Space>
              </Space>
            </Col>
          </Row>
        :
          <Row className='content-body' justify="space-around" align="middle" gutter={128} style={{ backgroundColor: '#fff' }}>
            <Col span={14}>
              <Space direction="vertical" size={32}>
                <Space direction="vertical" size={-8}>
                  <Text style={{ fontSize: 28, fontWeight: 'bold' }}>Welcome to The 2nd World Conference</Text>
                  <Text style={{ fontSize: 28, fontWeight: 'bold' }}>on Health and Social Sciences</Text>
                </Space>
                <Space direction="vertical" size={16}>
                  <Text style={{ fontSize: 15 }}>Join us for an enlightening exploration of the intersection between health and social sciences at Universitas Binawan. Under the theme of "Connecting People in Health and Social Sciences," this conference promises to be a platform for groundbreaking discussions, innovative ideas, and collaborative networking.</Text>
                  <Text style={{ fontSize: 15 }}>Explore cutting-edge topics such as artificial intelligence (AI) in healthcare, the integration of nursing and midwifery into public health systems, and the impact of virtual reality (VR) on safety education. Whether you're a researcher, practitioner, educator, or enthusiast, WCHSS offers a unique opportunity to engage with global thought leaders and contribute to the advancement of these vital fields.</Text>
                  {/* <Text style={{ fontSize: 15 }}>"This activity aims to develop and evaluate research-based interventions to improve public health, reduce social inequalities in health, and communicate research results and implications to a wide range of audiences."</Text> */}
                </Space>
              </Space>
            </Col>
            <Col span={10}>
              <Image
                width={'100%'}
                src={Pict}
                preview={false}
                style={{ objectFit: 'cover' }}
              />
            </Col>
          </Row>
      }
    </React.Fragment>
  )
}

export default Welcome